import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { UNSAFE_getResolveToMatches } from '@remix-run/router';



import translationENG from "./locales/en.json";
import translationAR from "./locales/ae.json";
import translationUR from "./locales/ur.json";
import translationBD from "./locales/bd.json";
import translationIN from "./locales/in.json";



// the translations
const resources = {
 
  en: {
    translation: translationENG,
  },

  ae: {
    translation: translationAR,
  },
  ur: {
    translation: translationUR,
  },
  bd: {
    translation: translationBD,
  },
  in: {
    translation: translationIN,
  },
};

const language = localStorage.getItem("I18N_LANGUAGE");
if (!language) {
  localStorage.setItem("I18N_LANGUAGE", "en");
}

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "en", // use en if detected lng is not available

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
